import ScrollMagic from 'scrollmagic';
// import 'scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';
import ieScrollFix from 'utils/ie-scroll-fix';


const $houseContainer = $('.js-house-container');
const $houseOuterContainer = $('.js-house-outer-container');
let lastScrollPosition = 0;

if ($houseContainer.length > 0) {
  initHouseScrollers();
}

function initHouseScrollers() {
  window.addEventListener('scroll', () => {
    if (window.pageYOffset > lastScrollPosition) {
      handleScrollDown();
    } else {
      handleScrollUp();
    }

    lastScrollPosition = window.pageYOffset;
  });

  function handleScrollUp() {
    const $svg = $houseContainer.find('svg');
    const houseSvgTop = $svg.offset().top;

    // const houseYTop = $houseContainer.offset().top;
    const houseContainerTop = $houseOuterContainer.offset().top;
    // const houseYOffset = $houseContainer.offset().top + $houseContainer.innerHeight();
    const houseContainerYOffset = $houseOuterContainer.offset().top + $houseOuterContainer.innerHeight();

    if (houseSvgTop <= houseContainerTop && !$houseContainer.hasClass('stuck-top')) {
      $houseContainer.removeClass('fixed');
      $houseContainer.addClass('stuck-top');
    } else if (((window.pageYOffset + window.innerHeight) < houseContainerYOffset) && $houseContainer.hasClass('stuck-bottom')) {
      $houseContainer.removeClass('stuck-bottom');
      $houseContainer.addClass('fixed');
    }
  }

  function handleScrollDown() {
    // const houseYTop = $houseContainer.offset().top;
    // const houseContainerTop = $houseOuterContainer.offset().top;
    const houseYOffset = $houseContainer.offset().top + $houseContainer.innerHeight();
    const houseContainerYOffset = $houseOuterContainer.offset().top + $houseOuterContainer.innerHeight();

    if (houseYOffset >= houseContainerYOffset && !$houseContainer.hasClass('stuck-bottom')) {
      $houseContainer.removeClass('fixed');
      $houseContainer.addClass('stuck-bottom');
    } else if ((window.pageYOffset + window.innerHeight) > houseYOffset) {
      $houseContainer.removeClass('stuck-top');
      $houseContainer.addClass('fixed');
    }
  }

  if ($houseContainer.length > 0) {
    ieScrollFix();

    const controller = new ScrollMagic.Controller();
    const scrollers = document.querySelectorAll('.js-house-scroll-item');

    Array.forEach(scrollers, (element, index) => {
      const scene = new ScrollMagic.Scene({
        triggerElement: element,
        triggerHook: (window.matchMedia('(max-width: 768px)').matches && index > 0) ? 0.5 : 0.6,
        reverse: true,
      });

      // scene.addIndicators({
      //   name: 'Items',
      // });
      scene.setClassToggle(element, 'active');
      scene.on('end', (e) => {
        if (e.scrollDirection === 'FORWARD' && (index + 1) === scrollers.length) {
          element.classList.add('dont-fade-out', 'end-active');
        } else {
          element.classList.add('fade-out');
        }
      });
      scene.on('start', (e) => {
        if (e.scrollDirection === 'REVERSE') {
          element.classList.remove('dont-fade-out');
          element.classList.remove('fade-out');
          element.classList.remove('end-active');
        }
      });
      scene.addTo(controller);
    });
  }
}
